<template>
  <v-app id="inspire">
    <Header
      v-if="
        $router.currentRoute.name !== 'login' &&
          $router.currentRoute.name !== 'forgot-pwd' &&
          $router.currentRoute.name !== 'chat'
      "
    ></Header>

    <v-main>
      <v-container
        fluid
        class="page-wrapper"
        :class="$router.currentRoute.name === 'chat' ? 'fill-height pa-0' : ''"
      >
        <router-view />
        <QuickActions v-if="isAuthenticated" />
      </v-container>
    </v-main>
    <new-content-available-snackbar
      v-if="newContentAvailable"
      class="new-content-available-toastr"
      :refreshing-app="refreshingApp"
      @refresh="serviceWorkerSkipWaiting"
    />
    <Sidebar v-if="isAuthenticated"></Sidebar>

    <v-snackbar v-model="showSnackbar">
      <v-icon v-if="snackbar.type === 'error'" color="error" class="mr-5">
        mdi-alert
      </v-icon>
      <v-icon v-if="snackbar.type === 'success'" color="success" class="mr-5">
        mdi-check
      </v-icon>
      <v-icon v-if="snackbar.type === 'warning'" color="warning" class="mr-5">
        mdi-exclamation
      </v-icon>
      {{ snackbar.message }}
      <v-icon v-if="snackbar.type === 'warning'" color="warning" class="mr-5">
        mdi-exclamation
      </v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
          v-if="!snackbar.action"
          text
          color="primary"
          v-bind="attrs"
          @click.native="showSnackbar = false"
        >
          {{ $vuetify.lang.t('$vuetify.CLOSE') }}
        </v-btn>
        <v-btn
          v-else
          text
          color="accent"
          v-bind="attrs"
          @click.native="snackbar.action()"
        >
          {{ snackbar.actionMessage }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Header from '@/layouts/header/Header'
import Sidebar from '@/layouts/sidebar/Sidebar'
import QuickActions from '@/components/QuickActions'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import NewContentAvailableSnackbar from '@/components/NewContentAvailableSnackbar'
import countries from '@/assets/countries'

export default {
  name: 'Layout',

  components: {
    Header,
    Sidebar,
    NewContentAvailableSnackbar,
    QuickActions
  },

  props: {
    source: String
  },
  data: () => ({
    countries,
    fab: false,
    direction: 'top',
    transition: 'scale-transition'
  }),
  computed: {
    ...mapGetters('authentication', ['isAuthenticated', 'user']),
    ...mapGetters('app', ['selectedLanguage', 'newContentAvailable']),
    ...mapState('app', ['refreshingApp', 'snackbar']),
    showSnackbar: {
      get() {
        return this.snackbar.show
      },
      set(value) {
        return this.$store.commit('app/setSnackbar', {
          show: value,
          type: null,
          message: null
        })
      }
    }
  },
  watch: {
    selectedLanguage(newValue) {
      this.$vuetify.lang.current = newValue.code
    }
  },
  mounted() {
    // if (this.$router.currentRoute.name !== 'chat') {
    //   setTimeout(() => {
    //     if (!window.Tawk_API.isChatHidden()) {
    //       window.Tawk_API.hideWidget()
    //     }
    //   }, 1000)
    // }
    // console.log('teretere', this.$route.query)
    // console.log(window.Tawk_API)
    // window.Tawk_API.visitor = {
    //   name: this.user.name,
    //   email: this.user.email
    // }
    // window.Tawk_API.maximize()
    // setTimeout(function() {
    //   if (window.Tawk_API.onLoaded) {
    //     if (this.user) {
    //       window.Tawk_API.visitor = {
    //         name: this.user.name,
    //         email: this.user.email
    //       }
    //     }
    //     window.Tawk_API.maximize()
    //   }
    // }, 2500)
  },
  async created() {
    const languageSetByUser = localStorage.getItem('locale')
    // Check if locale is set in localStorage. If not then select locale based on ip address
    if (!languageSetByUser) {
      try {
        const response = await fetch('https://ip2c.org/s')
        const result = (response || '').toString()

        if (!result || result[0] !== '1') {
          throw new Error('unable to fetch the country')
        }
        const selectedCountry = this.countries.find(
          country => country.country_code === result.substr(2, 2)
        )
        if (selectedCountry.country_code === 'EE') {
          this.$vuetify.lang.current = 'et'
          this.$store.commit('app/setLanguage', true)
          this.$store.commit('app/setSelectedLanguage', {
            code: 'et',
            title: 'Eesti',
            flag: 'EE'
          })
        } else {
          this.$vuetify.lang.current = 'en'
          this.$store.commit('app/setLanguage', true)
          this.$store.commit('app/setSelectedLanguage', {
            code: 'en',
            title: 'English',
            flag: 'GB'
          })
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    } else {
      const locale = JSON.parse(languageSetByUser)
      this.$vuetify.lang.current = locale.code
      this.$store.commit('app/setLanguage', true)
      this.$store.commit('app/setSelectedLanguage', locale)
    }
  },

  methods: {
    ...mapMutations({
      setCustomizerDrawer: 'SET_CUSTOMIZER_DRAWER'
    }),
    ...mapActions('app', ['serviceWorkerSkipWaiting'])
  }
}
</script>

<style>
.primary-shadow {
  box-shadow: 0 0 15px 5px rgba(248, 192, 26, 0.1) !important;
}
.theme--light.v-application {
  background: #725c711a !important;
}
/* .theme--light.v-application {
  background: #fff !important;
} */
</style>
